<ng-container *ngIf="config?.search">
    <div class="input-container filter-search">
        <div class="input-bx">
            <a href="javascript:void(0)" aria-label="blank" class="input-icon visible">
                <span class="icon icon-va-filter-list"></span>
            </a>
            <input id="" placeholder="Search Filter" type="text" class="p-l-38" required name="account_name" #value
                (keyup)="applyFilter($event)">
        </div>
    </div>
</ng-container>
<perfect-scrollbar>
    <!-- <div class="card-container" (click)="cardAction($event)"> -->
    <div class="card-container">
        <ng-container *ngFor="let workspace of workspaceList | searchFilter:searchValue;let index=index">
            <div class="cards-main-wrap">
                <mat-card class="card-wrap child-card" data-type="navigate-info" [attr.data-index]="index">
                    <div vcpCardHover [index]="index" class="overlay child-card" data-type="view-workspace"
                        [attr.data-index]="index" *ngIf="config?.overlay">
                        <div class="overlay-content relative">
                            <div class="menu-icon drop-btn relative" fxLayout="row" fxLayoutAlign="space-around center">
                                <div class="p-l-20 p-r-20 drdn cursor-pointer" aria-label="blank" fxLayout="column"
                                    fxLayoutAlign="center flex-end" (click)="toggleInfo(index)">
                                   <!--<span class="icon-box icon-va-more-vert"></span>
                                    <div class="requst-drdn" id="showOption{{index}}">
                                        <a class="" id="leave" href="javascript:void(0)"
                                            (click)="statusAction(index,'leave')">Request to
                                            leave</a>
                                    </div>-->
                                </div>
                            </div>


                            <div class="btn-wrap" fxLayout="column" fxLayoutGap="24px" fxLayoutAlign="center center">
                                <button mat-button *ngIf="!workspace?.default" class="default" id="default"
                                    data-type="default" (click)="cardAction($event)" [attr.data-index]="index">
                                    Set as default
                                </button>
                               <!-- <button *ngIf="config?.share" mat-button class="primary-cta share">
                                    <mat-icon fxLayout="row" fxLayoutAlign="center center">
                                        <span class="icon-box icon-va-share"></span>
                                    </mat-icon>
                                    Share no(op)
                                </button>-->
                            </div>
                        </div>
                    </div>
                    <div [class.p-r-16]="workspace?.status?.toLowerCase()==='active' ||
                 (workspace?.type?.toLowerCase()==='invited'
                    && workspace?.status?.toLowerCase()==='pending')" fxLayout="row">
                        <mat-card-header>
                            <div class="prfl-img" mat-card-avatar>
                                <img [src]="workspace?.iconUrl ? workspace?.iconUrl:'./assets/images/leather-nunchuck.png'"
                                    alt="avtar" width="40px" height="40px" class="border-radius20">
                            </div>
                            <mat-card-title class="title word-break semi-bold m-b-10"
                                matTooltip="{{workspace?.workspaceName}}">
                                {{workspace?.workspaceName}}
                            </mat-card-title>
                            <mat-card-subtitle *ngIf="config?.subHeading" class="sub-title word-break m-b-0 txt-12">
                                {{workspace?.workspaceHierarchy}}
                            </mat-card-subtitle>
                        </mat-card-header>
                    </div>

                    <mat-card-content>
                        <div class="card-content"
                            [class.p-r-16]="workspace?.status?.toLowerCase()==='active' || (workspace?.type?.toLowerCase()==='invited' && workspace?.status?.toLowerCase()==='pending')"
                            fxLayout="column" fxLayoutAlign="space-between">

                            <div class="your-role" fxLayout="row" fxLayoutAlign="space-between start"
                                *ngIf="config?.yourRole">
                                <div>
                                    <span class="heading">Your Role</span>
                                    <p class="heading-data word-break">{{workspace?.role}}</p>
                                </div>
                                <div>
                                    <span class="heading">Status</span>
                                    <p class="heading-data"
                                        [class.active]="!workspace?.default && workspace?.status.toLowerCase()!='disabled'">
                                        <ng-container
                                            *ngIf="workspace?.status.toLowerCase()=='disabled';else statusTemp">
                                            {{workspace?.status}}
                                        </ng-container>
                                        <ng-template #statusTemp>
                                            {{workspace?.default ? 'Default':'Active'}}
                                        </ng-template>
                                    </p>

                                </div>
                            </div>

                            <div class="single-data" *ngIf="config?.resource">
                                <span class="heading">Assigned Resources</span>
                                <p class="heading-data">
                                    <span>{{workspace?.resources}}</span>
                                    <span class="pill">{{workspace?.resources}}</span>
                                </p>
                            </div>
                            <div class="single-data" *ngIf="config?.assignedRole">
                                <span class="heading">Assigned Role</span>
                                <p class="heading-data word-break">{{workspace?.role}}</p>
                            </div>
                            <div class="single-data" *ngIf="config?.role">
                                <span class="heading">Role</span>
                                <p class="heading-data word-break">{{workspace?.role}}</p>
                            </div>
                            <div class="single-data" *ngIf="config?.workspaceRole">
                                <span class="heading">Workspace Role</span>
                                <p class="heading-data word-break">{{workspace?.role}}</p>
                            </div>
                            <div class="single-data" *ngIf="config?.invitedBy">
                                <span class="heading">Invited By</span>
                                <p class="heading-data word-break">{{workspace?.createdBy}}</p>
                                <p class="more-data word-break">{{workspace?.emailId}}</p>
                            </div>
                            <div class="single-data" *ngIf="config?.owner">
                                <span class="heading">Workspace Owner</span>
                                <p class="heading-data word-break">{{workspace?.createdBy}}</p>
                                <p class="more-data word-break">{{workspace?.emailId}}</p>
                            </div>
                            <div class="card-timeline single-data" *ngIf="config?.time">
                                <p class="">{{workspace?.invitedOn | dayCount}}</p>
                            </div>
                        </div>
                    </mat-card-content>
                    <div class="card-footer" fxLayout="row" fxLayoutAlign="space-between center">
                        <div *ngIf="config?.status">
                            <span class="pill">
                                {{workspace?.status?.toLowerCase()==='active' ||
                                workspace?.status?.toLowerCase()==='disabled'?'Joined':
                                'Leave request sent'}}</span>
                        </div>
                        <div class="badges join-lbl" *ngIf="config?.visibility">
                            <span class="semi-bold">{{workspace?.visibility}}</span>
                        </div>
                        <div class="badges" *ngIf="config?.member">
                            <span class="prfl-icon">
                                <img src="./assets/images/avtar.png" alt="avtar">
                            </span>
                            <span class="prfl-icon">
                                <img src="./assets/images/avtar.png" alt="avtar">
                            </span>
                            <span class="prfl-icon">
                                <img src="./assets/images/avtar.png" alt="avtar">
                            </span>
                        </div>
                    </div>
                    <mat-card-actions fxLayout="row" fxLayoutGap="8px" *ngIf="config?.inviteButton">
                        <button class="primary-cta" mat-button data-type="accept" (click)="cardAction($event)"
                            [attr.data-index]="index">Accept</button>
                        <button class="tertiary-cta" mat-button data-type="not-now" (click)="cardAction($event)"
                            [attr.data-index]="index">Not
                            Now</button>
                    </mat-card-actions>
                    <div fxLayout="row" class="request" fxLayoutAlign="flex-start center" fxLayoutGap="8px"
                        *ngIf="config?.join">
                        <span class="anchor-cta"
                            *ngIf="workspace?.status?.toLowerCase()==='wrjrs' || workspace?.status?.toLowerCase()==='wjrs'">Request
                            sent</span>
                        <span class="anchor-cta" data-type="rejoin"
                            *ngIf="workspace?.status?.toLowerCase()==='not_exist' || workspace?.status?.toLowerCase()==='inactive'"
                            [attr.data-index]="index">Request to
                            {{workspaceType?'join':'Re-join'}}</span>
                    </div>
                </mat-card>
            </div>
        </ng-container>
    </div>
</perfect-scrollbar>
